// Centralized La Saponaria locations list
// Used across the application for consistency

export const laSaponariaLocations = [
  'Ancona',
  'Bastia Umbra',
  'Battipaglia',
  'Bologna',
  'Civitanova',
  'Fano',
  'Milano Centro',
  'Milano Solari',
  'Modena',
  'Montebelluna',
  'Parma',
  'Pescara',
  'Ravenna',
  'Rimini',
  'Roma Cola di Rienzo',
  'Roma Bergamo',
  'Sassari',
  'Senigallia',
  'Viareggio',
  'Pesaro (Sede e Spaccio)',
]
